module.exports = require('../../dist/src/themes/backoffice');



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/themes/backoffice/index.js
// module id = 1357
// module chunks = 0